import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AdminLogin from '../views/AdminLogin.vue'
import AdminHome from '../views/AdminHome.vue'
import AdminNewsList from '../views/AdminNewsList.vue'
import AdminNewsEdit from '../views/AdminNewsEdit.vue'
import AdminNewsAdd from '../views/AdminNewsAdd.vue'
import AdminNewsCheckList from '../views/AdminNewsCheckList.vue'
import AdminNewsCheckShow from '../views/AdminNewsCheckShow.vue'
import AdminNewsSearchList from '../views/AdminNewsSearchList.vue'
import AdminNewsDeleteShow from '../views/AdminNewsDeleteShow.vue'
import AdminAssociationShow from '../views/AdminAssociationShow.vue'
import AdminAssociationEdit from '../views/AdminAssociationEdit.vue'
import AdminAssociationList from '../views/AdminAssociationList.vue'
import AdminAssociationShowOther from '../views/AdminAssociationShowOther.vue'
import AdminAssociationOtherEdit from '../views/AdminAssociationOtherEdit.vue'
import AdminAssociationOtherAdd from '../views/AdminAssociationOtherAdd.vue'
import AdminMembersList from '../views/AdminMembersList.vue'
import AdminMemberShow from '../views/AdminMemberShow.vue'
import AdminMemberEdit from '../views/AdminMemberEdit.vue'
import AdminMemberAdd from '../views/AdminMemberAdd.vue'
import AdminMembersSearch from '../views/AdminMembersSearch.vue'
import AdminIndexBanner from '../views/AdminIndexBanner.vue'
import AdminIndexBannerAdd from '../views/AdminIndexBannerAdd.vue'
import AdminIndexColors from '../views/AdminIndexColors.vue'
import AdminIndexNews from '../views/AdminIndexNews.vue'
import AdminIndexVideos from '../views/AdminIndexVideos.vue'
import AdminUsersList from '../views/AdminUsersList.vue'
import AdminUsersAdd from '../views/AdminUsersAdd.vue'
import AdminUsersPasswordEdit from '../views/AdminUsersPasswordEdit.vue'

//web
import WebColumnList from '../views/WebColumnList.vue'
import WebNewsShow from '../views/WebNewsShow.vue'
import WebAssoDescription from '../views/WebAssoDescription.vue'
import WebAssoRegulations from '../views/WebAssoRegulations.vue'
import WebAssoContact from '../views/WebAssoContact.vue'
import WebAssoCouncil from '../views/WebAssoCouncil.vue'
import WebAssoLeaders from '../views/WebAssoLeaders.vue'
import WebAssoOrganization from '../views/WebAssoOrganization.vue'
import WebSubassociation from '../views/WebSubassociation.vue'
import WebSearch from '../views/WebSearch.vue'
import WebWorkersList from '../views/WebWorkersList.vue'
import WebWorkersShow from '../views/WebWorkersShow.vue'
import WebWorkersPictures from '../views/WebWorkersPictures.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/columns/list',
    name: 'WebColumnList',
    component: WebColumnList
  }, {
    path: '/news/show',
    name: 'WebNewsShow',
    component: WebNewsShow
  }, {
    path: '/associationinfo/description',
    name: 'WebAssoDescription',
    component: WebAssoDescription
  }, {
    path: '/associationinfo/regulations',
    name: 'WebAssoRegulations',
    component: WebAssoRegulations
  }, {
    path: '/associationinfo/organization',
    name: 'WebAssoOrganization',
    component: WebAssoOrganization
  }, {
    path: '/associationinfo/leaders',
    name: 'WebAssoLeaders',
    component: WebAssoLeaders
  }, {
    path: '/associationinfo/council',
    name: 'WebAssoCouncil',
    component: WebAssoCouncil
  }, {
    path: '/about/contact',
    name: 'WebAssoContact',
    component: WebAssoContact
  }, {
    path: '/subassociation',
    name: 'WebSubassociation',
    component: WebSubassociation
  },
  {
    path: '/search/news',
    name: 'WebSearch',
    component: WebSearch
  },
  {
    path: '/100/workers/list',
    name: 'WebWorkersList',
    component: WebWorkersList
  },
  {
    path: '/100/workers/show',
    name: 'WebWorkersShow',
    component: WebWorkersShow
  },
  {
    path: '/100/workers/pictures',
    name: 'WebWorkersPictures',
    component: WebWorkersPictures
  },
  {
    path: '/manage/home',
    name: 'AdminHome',
    component: AdminHome,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  {
    path: '/manage/news/list',
    name: 'AdminNewsList',
    component: AdminNewsList,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/news/add',
    name: 'AdminNewsAdd',
    component: AdminNewsAdd,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/news/edit/:id',
    name: 'AdminNewsEdit',
    component: AdminNewsEdit,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/news/check/list',
    name: 'AdminNewsCheckList',
    component: AdminNewsCheckList,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/news/check/show',
    name: 'AdminNewsCheckShow',
    component: AdminNewsCheckShow,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/news/search',
    name: 'AdminNewsSearchList',
    component: AdminNewsSearchList,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/news/delete/show',
    name: 'AdminNewsDeleteShow',
    component: AdminNewsDeleteShow,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/association/mine/show',
    name: 'AdminAssociationShow',
    component: AdminAssociationShow,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/association/mine/edit',
    name: 'AdminAssociationEdit',
    component: AdminAssociationEdit,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/association/list',
    name: 'AdminAssociationList',
    component: AdminAssociationList,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/association/other/show',
    name: 'AdminAssociationShowOther',
    component: AdminAssociationShowOther,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/association/other/edit',
    name: 'AdminAssociationOtherEdit',
    component: AdminAssociationOtherEdit,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/association/other/add',
    name: 'AdminAssociationOtherAdd',
    component: AdminAssociationOtherAdd,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/members/list',
    name: 'AdminMembersList',
    component: AdminMembersList,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/members/show',
    name: 'AdminMemberShow',
    component: AdminMemberShow,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/members/edit',
    name: 'AdminMemberEdit',
    component: AdminMemberEdit,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/members/add',
    name: 'AdminMemberAdd',
    component: AdminMemberAdd,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/members/search',
    name: 'AdminMembersSearch',
    component: AdminMembersSearch,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/sliders/banners/list',
    name: 'AdminIndexBanner',
    component: AdminIndexBanner,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/sliders/colors/list',
    name: 'AdminIndexColors',
    component: AdminIndexColors,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/sliders/news/list',
    name: 'AdminIndexNews',
    component: AdminIndexNews,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/sliders/videos/list',
    name: 'AdminIndexVideos',
    component: AdminIndexVideos,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/sliders/banners/add',
    name: 'AdminIndexBannerAdd',
    component: AdminIndexBannerAdd,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/users/list',
    name: 'AdminUsersList',
    component: AdminUsersList,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/users/add',
    name: 'AdminUsersAdd',
    component: AdminUsersAdd,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },
  {
    path: '/manage/users/edit',
    name: 'AdminUsersPasswordEdit',
    component: AdminUsersPasswordEdit,
    meta: {
      keepAlive: true,
      requiresAuth: true
    }
  },

]

const router = new VueRouter({
  routes
})

export default router
